import React from "react";
import Img from "./Img";

export default function HandicapDesc(props) {
    const desc = props.desc;

    return (
        <div className="c_61">
            {desc.length === 0 ?
                <Img className="c_61_1" src="icon_caution_my_account.svg" height="16px" width="16px" />
                :
                desc
            }
        </div>
    );
}
